import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toaster = ({ autoClose = 3000 }) => {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={autoClose}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={5}
      enableMultiContainer={false}
      containerId="main-toast-container"
    />
  );
};

export default Toaster;
